/**
 * Utilidades para manejo de RUT chileno
 */

/**
 * Normaliza un RUT chileno a formato sin puntos y con guión
 * Ejemplo: "12.345.678-9" -> "12345678-9"
 *          "12345678-9" -> "12345678-9"
 *          "123456789" -> "12345678-9"
 *          "12.345.678-K" -> "12345678-K"
 * @param {string} rut - RUT a normalizar
 * @returns {string} - RUT normalizado (sin puntos, con guión, DV en mayúscula)
 */
export const normalizarRut = (rut) => {
    if (!rut) return '';

    // Convertir a string y eliminar espacios
    let rutLimpio = String(rut).trim();

    // Eliminar puntos
    rutLimpio = rutLimpio.replace(/\./g, '');

    // Si no tiene guión, intentar agregarlo (el último carácter es el DV)
    if (!rutLimpio.includes('-') && rutLimpio.length > 1) {
        const cuerpo = rutLimpio.slice(0, -1);
        const dv = rutLimpio.slice(-1);
        rutLimpio = `${cuerpo}-${dv}`;
    }

    // Convertir DV a mayúscula (para el caso de "k" -> "K")
    const partes = rutLimpio.split('-');
    if (partes.length === 2) {
        rutLimpio = `${partes[0]}-${partes[1].toUpperCase()}`;
    }

    return rutLimpio;
};

/**
 * Compara dos RUTs normalizándolos primero
 * @param {string} rut1 - Primer RUT
 * @param {string} rut2 - Segundo RUT
 * @returns {boolean} - true si son iguales
 */
export const compararRuts = (rut1, rut2) => {
    return normalizarRut(rut1) === normalizarRut(rut2);
};

/**
 * Formatea un RUT con puntos y guión para mostrar
 * Ejemplo: "12345678-9" -> "12.345.678-9"
 * @param {string} rut - RUT a formatear
 * @returns {string} - RUT formateado
 */
export const formatearRut = (rut) => {
    if (!rut) return '';

    // Primero normalizar
    const rutNormalizado = normalizarRut(rut);
    const partes = rutNormalizado.split('-');

    if (partes.length !== 2) return rut;

    const cuerpo = partes[0];
    const dv = partes[1];

    // Agregar puntos de miles
    const cuerpoConPuntos = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${cuerpoConPuntos}-${dv}`;
};
